import React, { createElement } from 'react';
import cn from '@utils/cn';
import { SharedTextProps, VARIANTS } from './constants';

export { TextVariant } from './constants';

export type TextBlockProps = SharedTextProps & {
  children: React.ReactNode;
};

export default function TextBlock({ children, variant, as, className, style, title, id }: TextBlockProps) {
  const render = VARIANTS[variant];

  return createElement(
    as ?? render.element,
    {
      className: cn('text-foreground font-the-future font-medium', render.className, className),
      style,
      title,
      id,
    },
    children,
  );
}
